exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card-list {\n  margin: 0 auto 50px auto;\n}\n.card-list > .row:first-child {\n  margin-bottom: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./App/Components/DiagramViewer/modules/CardList.less
// module id = 301
// module chunks = 0